import React, { Component } from 'react'
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import { BASE } from '../api/api'
import Axios from 'axios'

class Verify extends Component {
    componentDidMount() {
        this.checklogin();
    }
    checklogin() {
        if (localStorage.getItem("token"))
            this.props.history.push('/')
    }
    render() {
        return (
            <div className="successpage">
                <Header />
                <div className="listing" >
                    <div className="main-content">
                        <div className="container">
                            <div className='img-circle'>
                                <img className="verify-img" src={process.env.PUBLIC_URL + '/signup/verify.png'} />
                            </div>
                            <div className='head verify-head'>
                                Verify your email
                            </div>
                            <div className="verify-info">A verification email is sent to your email address.</div>
                            <div className="verify-info">Please complete the email verification to activate your account.</div>

                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
export default Verify;